import { render, staticRenderFns } from "./ordersView.vue?vue&type=template&id=0441ee59&scoped=true"
import script from "./ordersView.vue?vue&type=script&lang=js"
export * from "./ordersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0441ee59",
  null
  
)

export default component.exports